import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["featuredField", "hideFeaturedField", "showFeaturedField", "requiredNormalField", "requiredTimedField"]

  static values = { timedAuction: Boolean }

  featuredFieldTargetConnected() {
    this.featuredFieldTarget.dispatchEvent(new Event("change"))
  }

  featuredOptionChanged({ target }) {
    this.#setFeatured(target.checked)
  }

  #setFeatured(isChecked) {
    this.hideFeaturedFieldTargets.forEach(target => {
      target.classList.toggle(this.hiddenClass, isChecked)
    })

    this.showFeaturedFieldTargets.forEach(target => {
      target.classList.toggle(this.hiddenClass, !isChecked)
    })

    this.requiredNormalFieldTargets.forEach(target => {
      if (isChecked) {
        target.removeAttribute("required")
      } else {
        target.setAttribute("required", true)
      }
    })

    this.requiredTimedFieldTargets.forEach(target => {
      if (isChecked || !this.timedAuctionValue) {
        target.removeAttribute("required")
      } else {
        target.setAttribute("required", true)
      }
    })
  }
}
